import { ToastContainer } from 'react-toastify'
import styled from 'styled-components'

export const StyledToastContainer = styled(ToastContainer)`
    /* .toast-container */
    bottom: 0;
    padding: 0 10px;
    .Toastify__toast {
        background: ${({ theme }) => theme.greyishBrown};
        margin: 0;
        padding: 5px 10px;
        min-height: 25px;
        border-radius: 4px;
        cursor: auto;
        margin-bottom: 10px;
    }
    .Toastify__toast--error {
        background: ${({ theme }) => theme.pastelRed};
    }
    .Toastify__toast--warning {}
    .Toastify__toast--success {
        background: ${({ theme }) => theme.grassyGreen};
    }
    .Toastify__toast-body {
        font-family: 'Lato', sans-serif;
        color: ${({ theme }) => theme.whiteTwo};
        font-weight: ${({ theme }) => theme.fontWeight.bold};
        letter-spacing: 0.42px;
        font-size: 11px;
    }
    .Toastify__progress-bar {
        height: 2px;
        background: ${({ theme }) => theme.whiteTwo};
        opacity: 0.5;
    }
  `;